/**
 * @description Exibe a imagem do header
 * @module HeaderImage
 * @since Agosto 2025
 */

import React from "react";
import { Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import logo from "@/assets/fluxmed-logo-horizontal-white.png";

const HeaderImage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <Stack
      width="100%"
      maxWidth="170px"
      position="relative"
      height="40px"
      sx={{ cursor: "pointer" }}
      onClick={() => navigate("/")}
    >
      <img src={logo} alt="Logo fluxmed" />
    </Stack>
  );
};

export { HeaderImage };
